<template>
  <div v-loading="loading" style="height: 100%;">
    <div class="tabs">
      <div @click="addClass(0)" :class="{ current: current == 0 }">
        未兑换（{{ count.no_exchange }}）
      </div>
      <div @click="addClass(1)" :class="{ current: current == 1 }">
        已兑换（{{ count.already_exchange }}）
      </div>
      <div @click="addClass(2)" :class="{ current: current == 2 }">
        已过期（{{ count.timeout }}）
      </div>
    </div>
    <div class="list" v-if="current === 0">
      <el-empty
        v-if="!noExchangeList.length"
        description="暂无数据 ~"
      ></el-empty>
      <div
        v-else
        class="card"
        v-for="item in noExchangeList"
        :key="item.number"
        @click="goExchange(item)"
      >
        <div class="info">
          <div class="time">
            限期使用
            <span>{{ item.use_start_date }}-{{ item.use_end_date }}</span>
          </div>
          <div class="name">{{ item.card_name }}</div>
          <div class="no">
            <img src="../../assets/card.png" alt />
            <div>{{ item.number }}</div>
          </div>
        </div>
        <div class="exchange">
          <span>去</span>
          <span style="margin: 3px 0;">兑</span>
          <span>换</span>
        </div>
      </div>
    </div>
    <div class="list" v-if="current === 1">
      <el-empty
        v-if="!alreadyExchangeList.length"
        description="暂无数据 ~"
      ></el-empty>
      <div
        v-else
        class="card_g"
        v-for="item in alreadyExchangeList"
        :key="item.number"
      >
        <div class="info">
          <div class="time">
            限期使用
            <span style="color: #fff;"
              >{{ item.use_start_date }}-{{ item.use_end_date }}</span
            >
          </div>
          <div class="name">{{ item.card_name }}</div>
          <div class="no">
            <img src="../../assets/card_g.png" alt />
            <div>{{ item.number }}</div>
          </div>
        </div>
        <div class="exchange" style="color: #5B5B5B;">
          <span>已</span>
          <span style="margin: 3px 0;">兑</span>
          <span>换</span>
        </div>
      </div>
    </div>
    <div class="list" v-if="current === 2">
      <el-empty v-if="!timeoutList.length" description="暂无数据 ~"></el-empty>
      <div v-else class="card_g" v-for="item in timeoutList" :key="item.number">
        <div class="info">
          <div class="time">
            限期使用
            <span style="color: #fff;"
              >{{ item.use_start_date }}-{{ item.use_end_date }}</span
            >
          </div>
          <div class="name">{{ item.card_name }}</div>
          <div class="no">
            <img src="../../assets/card_g.png" alt />
            <div>{{ item.number }}</div>
          </div>
        </div>
        <div class="exchange" style="color: #5B5B5B;">
          <span>已</span>
          <span style="margin: 3px 0;">过</span>
          <span>期</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCardBag, getCardStatusCount } from "@api/user";
export default {
  data() {
    return {
      current: 0,
      count: {},
      noExchangeList: [],
      alreadyExchangeList: [],
      timeoutList: [],
      loading: false
    };
  },
  created() {
    this.getCardStatusCount();
    this.getCardBag();
  },
  methods: {
    addClass(index) {
      this.current = index;
    },

    async getCardStatusCount() {
      this.loading = true;
      const res = await getCardStatusCount();
      this.count = res.data;
    },

    async getCardBag() {
      const params_0 = {
        status: 0,
        page: 1,
        limit: 100
      };
      const params_1 = {
        status: 1,
        page: 1,
        limit: 100
      };
      const params_2 = {
        status: -1,
        page: 1,
        limit: 100
      };
      try {
        const res_0 = await getCardBag(params_0);
        this.noExchangeList = res_0.data.list;

        const res_1 = await getCardBag(params_1);
        this.alreadyExchangeList = res_1.data.list;

        const res_2 = await getCardBag(params_2);
        this.timeoutList = res_2.data.list;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },

    goExchange(data) {
      if (data.is_optional_card > 0) {
        this.$router.push({
          path: "/user/active_exchange_goods/",
          query: {
            u: data.number,
            p: data.password,
            t: data.group_id
          }
        });
      } else {
        this.$router.push({
          path: "/user/active_exchange_only_goods",
          query: {
            u: data.number,
            p: data.password,
            t: data.group_id
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.tabs {
  margin-top: 10px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 30px;
  font-size: 16px;
}
.tabs div {
  line-height: 30px;
  border-bottom: 2px solid transparent;
  text-align: center;
}
.current {
  color: red;
  border-bottom: 2px solid red !important;
}

.list {
  padding: 20px;
}

.card,
.card_g {
  height: 150px;
  background: url("../../assets/card_bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  padding: 15px 20px;
  margin-bottom: 10px;
}

.card_g {
  background: url("../../assets/card_bg_g.png") no-repeat;
  background-size: 100% 100%;
}

.info {
  flex: 80%;
}

.time {
  color: #fff;
  font-size: 12px;
}
.time span {
  color: #f9edb3;
  margin-left: 5px;
}

.name {
  color: #fff;
  font-size: 22px;
  font-weight: 600;
  margin: 15px 0 35px;
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.no {
  font-size: 16px;
  color: #fff;
  display: flex;
  align-items: center;
}

.no img {
  width: 22px;
  height: 22px;
  margin-right: 5px;
}
.exchange {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #f9edb3;
}
</style>
